var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',_vm._l((_vm.APIData),function(item,index){return _c('v-list-item',{key:index},[_c('v-list-item-content',[_vm._v(_vm._s(item.full_name)+" "+_vm._s(item.tel))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }